module.exports = __webpack_public_path__ + "img/p3.2e2447d1.png";